export const result = {
    "no_results_yet": "No result yet",
    "see_result": "see result",
    "test_result": "test's result",
    "attempt": "Attempt",
};
